import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { types, actions } from './reducer';
import { extractError } from '@iso/lib//helpers/api';
import StatusTypeService from '@iso/services/SettingsService/OrderService/StatusTypeService';

function* viewOrderStatusType({ id }) {
    try {
        const response = yield call(StatusTypeService.getOne, id);
        yield put(actions.viewOrderStatusTypeSucceeded(response.data));
    } catch (error) {
        yield put(actions.viewOrderStatusTypeFailed(extractError(error)));
    }
}

function* watchViewOrderStatusType() {
    yield takeEvery(
        types.REQUEST_VIEW_ORDER_STATUS_TYPE,
        viewOrderStatusType,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewOrderStatusType),
    ]);
}

export default viewSaga;
